import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePrivatePensionAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PrivatePension';
import { useGlobalProductContext } from '../../../../../contexts';

import { PrivatePensionItemTypes } from '.';

export const PrivatePensionItemTablet: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePrivatePensionAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: 0 });
  };

  const topInfos = [
    {
      label: 'Tipo',
      value: <UI.Text color="neutral.dark">{offer.productTypeNormalized}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Mês',
      value: <UI.Text color="neutral.dark">{offer.monthlyRentabilityNormalized}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Ano',
      value: <UI.Text color="neutral.dark">{offer.annualRentabilityNormalized}</UI.Text>,
      maxW: '24%',
    },
    {
      label: '12 Meses',
      value: <UI.Text color="neutral.dark">{offer.twelveMonthsRentabilityNormalized}</UI.Text>,
      maxW: '24%',
    },
  ];

  const bottomInfos = [
    {
      label: 'Aplic. Min',
      value: <UI.Text color="neutral.dark">{offer.minimumApplicationNormalized}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Data início',
      value: <UI.Text color="neutral.dark">{offer.initialDateNormalized}</UI.Text>,
      maxW: '24%',
    },
    {
      label: 'Data de referência',
      value: <UI.Text color="neutral.dark">{offer.referenceDateNormalized}</UI.Text>,
      maxW: '24%',
    },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center">
          <UI.Text variant="semibold" color="neutral.darkest">
            {offer.productNameNormalized}
          </UI.Text>
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
        </HStack>
        <HStack alignItems="start">
          {topInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack>
          {bottomInfos.map(({ label, value, maxW }) => (
            <VStack maxW={maxW} w={maxW} space={Spacing['stack.quarck']} key={label}>
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
